export default __webpack_public_path__ + "static/media/calendar.55d9a1a9.svg";